import { styled } from "@mui/material/styles";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import { palette } from "../../themes/theme";

export const TableContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  borderRadius: "12px",
  overflow: "auto",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  backgroundColor: palette.background.default,
  maxWidth: "100%",
  flex: 1,
  minHeight: 0,
}));

export const StyledTable = styled(Table)({
  minWidth: 1200,
});

export const StyledTableHead = styled(TableHead)({
  backgroundColor: palette.background.dark,
});

export const StyledTableBody = styled(TableBody)({
  backgroundColor: palette.background.default,
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: palette.background.light,
  },
  "&:hover": {
    backgroundColor: `${palette.primary.main}15`,
    transition: "background-color 0.2s ease",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const StyledHeaderCell = styled(TableCell)({
  color: palette.text.white,
  fontWeight: 600,
  fontSize: "0.95rem",
  padding: "16px",
  borderBottom: `2px solid ${palette.primary.main}`,
  userSelect: "none",
});

export const StyledTableCell = styled(TableCell)({
  color: palette.text.dark,
  fontSize: "0.9rem",
  padding: "14px 16px",
  borderBottom: `1px solid ${palette.background.light}`,
});

export const PaginationContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2),
  backgroundColor: palette.background.light,
  borderTop: `1px solid ${palette.background.light}`,
}));

export const ActionButtonsContainer = styled(Box)({
  display: "flex",
  gap: "8px",
  alignItems: "center",
});

export const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "16px",
});

export const AddUserButton = styled(Button)({
  backgroundColor: palette.primary.main,
  color: palette.text.dark,
  fontWeight: 600,
  padding: "10px 24px",
  borderRadius: "8px",
  textTransform: "none",
  fontSize: "1rem",
  "&:hover": {
    backgroundColor: palette.primary.hover,
  },
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
});

export const LoadingContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "400px",
});
